import AxiosService from '../AxiosService';

// Buscar todos os produtos favoritos do cliente
const getFavorites = async (clientCode: string) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.get('/client/favorites', {
      headers: {
        'client-Code': clientCode,
      },
    });
    return response.data;
  } catch (error) {
    console.log('Erro ao buscar produtos favoritos:', error);
    throw error;
  }
};

// Adicionar produto aos favoritos
const addToFavorites = async (clientCode: string, sku: string) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.post(
      '/client/favorites',
      {
        sku: sku,
      },
      {
        headers: {
          'client-Code': clientCode,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log('Erro ao adicionar produto aos favoritos:', error);
    throw error;
  }
};

// Remover produto dos favoritos
const removeFromFavorites = async (clientCode: string, sku: string) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.delete(`/client/favorites/${sku}`, {
      headers: {
        'client-Code': clientCode,
      },
    });
    return response.data;
  } catch (error) {
    console.log('Erro ao remover produto dos favoritos:', error);
    throw error;
  }
};

// Verificar se um produto está nos favoritos
const isFavorite = async (clientCode: string, sku: string) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.get(`/client/favorites/check/${sku}`, {
      headers: {
        'client-Code': clientCode,
      },
    });
    return response.data;
  } catch (error) {
    console.log('Erro ao verificar se produto está nos favoritos:', error);
    return false;
  }
};

// Toggle favorito (adiciona se não existe, remove se existe)
const toggleFavorite = async (clientCode: string, sku: string) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.post(
      '/client/favorites/toggle',
      {
        sku: sku,
      },
      {
        headers: {
          'client-Code': clientCode,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.log('Erro ao alternar favorito:', error);
    throw error;
  }
};

// Limpar todos os favoritos do cliente
const clearFavorites = async (clientCode: string) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.delete('/client/favorites', {
      headers: {
        'client-Code': clientCode,
      },
    });
    return response.data;
  } catch (error) {
    console.log('Erro ao limpar favoritos:', error);
    throw error;
  }
};

export default {
  getFavorites,
  addToFavorites,
  removeFromFavorites,
  isFavorite,
  toggleFavorite,
  clearFavorites,
};
